import EventBuilder from "./_jquery.ga-lib";
import $ from "jquery";
// requires: _jquery.ga-lib.js
//Add your Google Analytics Events below
//ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);

//CATEGORY: Contact

jQuery(document).ready( ($) => {

    const debug = false;
    const eventBuilder = new EventBuilder(debug);

    eventBuilder.bind('a[href^="tel:"]', {
        trigger : 'click',
        name : "Phone Number Clicked"
    });

    eventBuilder.bind('a[href^="mailto:"]', {
        trigger : 'click',
        name : "Email Address Clicked"
    });

    eventBuilder.bind("a[title|='Schedule Service']", {
        trigger : 'click',
        name : "Schedule Now Clicked"
    });    

    eventBuilder.bind("a[title|='Get a Quote']", {
        trigger : 'click',
        name : "Header Get a Quote Clicked"
    });

    eventBuilder.bind("a[title|='Pay for Service']", {
        trigger : 'click',
        name : "Pay for Service | Clicked"
    });    

    eventBuilder.bind(".social-links li a", {
        trigger : 'click',
        name : "Social Media | Clicked"
    });   

    eventBuilder.bind("a[title|='Check Repair Status']", {
        trigger : 'click',
        name : "Check Repair Status | Clicked"
    });    

    eventBuilder.bind('a[href^="https://maps.google.com/maps?saddr"]', { 
        category: "Engagement", 
        action: "Click", 
        beforeLabel: "Address Clicked | ",
        label: function(element) { 
            return $(element).data("address") || $(element).text();
        }, 
    });

    /*
    * Phone Number Clicked - From Location - WPSL cards
    */
    $(document).on('click', '.wpsl-store-location a[href^="tel:"]', function(e){
        
        let $locationName = $(this).parents('.wpsl-store-location').find('h4 > a').text();
        let $data = $(this).text();
        let $label      = 'Phone Number Clicked | ' + $locationName + ' | ' + $data;

        ga('send', 'event', 'Contact' , 'Click' , $label );
    })
    
    /*
    * Phone Number Clicked - From Location - Location Singles
    */
    $('.single-wpsl_stores').on('click', 'a[href^="tel:"]', function(e){
        
        let $locationName = $(this).parents('.sidebar-wrapper').find('h4').text();
        let $data = $(this).text();
        let $label      = 'Phone Number Clicked | ' + $locationName + ' | ' + $data;

        ga('send', 'event', 'Contact' , 'Click' , $label );
    })
    
    /*
    * Address Clicked/Get Directions Clicked - From Location - WPSL cards
    */
    $(document).on('click', '.wpsl-store-location a.wpsl-directions', function(e){
    
        let $locationName = $(this).parents('.wpsl-store-location').find('h4 > a').text();
        let $label      = 'Address Clicked | ' + $locationName ;

        ga('send', 'event', 'Engagement' , 'Click' , $label );
    })

    /*
    * Address Clicked/Get Directions Clicked - Location Singles
    */
    $('.single-wpsl_stores').on('click', 'a[href^="http"]', function(e){
        
        let $locationName = $(this).parents('.sidebar-wrapper').find('h4').text();
        let $label      = 'Address Clicked | ' + $locationName ;

        ga('send', 'event', 'Engagement' , 'Click' , $label );
    })
    
    /*
    * SMS Link Clicked - WPSL cards
    */
    $(document).on('click', '.wpsl-store-location a[href^="sms:"]', function(e){
        
        let $locationName = $(this).parents('.wpsl-store-location').find('h4 > a').text();
        let $label = 'SMS Link Clicked | ' + $locationName;
        
        ga('send', 'event', 'Contact', 'Click' , $label );
    })

    /*
    * SMS Link Clicked - Location Singles
    */
    $('.single-wpsl_stores').on('click', 'a[href^="sms:"]', function(e){
        
        let $locationName = $(this).parents('.sidebar-wrapper').find('h4').text();
        let $label = 'SMS Link Clicked | ' + $locationName;
        
        ga('send', 'event', 'Contact', 'Click' , $label );
    })

    /*
     *  Event Signups
     */
    $(document).on('click', '.event-details a', function(e){
        // e.preventDefault();

        let $eventTitle = $(this).closest('.event-single').find('h1').text();
        let $label      = 'Event Sign Up Clicked | ' + $eventTitle;
        
        ga('send', 'event', 'Engagement' , 'Click' , $label );
    })
    
    
    // Schedule Request Submission
    eventBuilder.bind("#gform_2", { 
        trigger : 'submit',
        category: "Contact",
        action: "Submit", 
        beforeLabel: "Form Submitted | ",
        label: "Quote Service Request"
    });
    
    // Contact: Form Submitted
    eventBuilder.bind("#gform_1", { 
        trigger : 'submit',
        category: "Contact",
        action: "Submit", 
        beforeLabel: "Form Submitted | ",
        label: "Contact"
    });

    // Career Form Submission
    eventBuilder.bind("#gform_3", { 
        trigger : 'submit',
        category: "Contact",
        action: "Submit", 
        beforeLabel: "Form Submitted | ",
        label: "Career"
    });

    // Zip Code Search
    eventBuilder.bind("#wpsl-search-btn", { 
        trigger : 'click',
        category: "Engagement",
        action: "Click", 
        beforeLabel: "Zip Code Search | ",
        label: ''
    });


} );	